import { API_BASE_URL } from '../config/api';
import { parseApiResponse } from './apiHelpers';

const BASE = `${API_BASE_URL}/creative-enrollments`;

export const submitCreativeEnrollment = async ({ name, email, phone, level, goal }) => {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, phone, level, goal }),
  });
  return parseApiResponse(res);
};

export const fetchEnrollmentCount = async () => {
  const res = await fetch(`${BASE}/count`);
  const data = await parseApiResponse(res);
  return data.data.total;
};

export const fetchAllCreativeEnrollments = async (authHeaders) => {
  const res = await fetch(BASE, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const fetchCreativeEnrollmentStats = async (authHeaders) => {
  const res = await fetch(`${BASE}/stats`, { headers: authHeaders });
  const data = await parseApiResponse(res);
  return data.data;
};

export const deleteCreativeEnrollment = async (id, authHeaders) => {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'DELETE',
    headers: authHeaders,
  });
  return parseApiResponse(res);
};

export const updateCreativeEnrollmentPayment = async (id, { amountPaid, discountAmount }, authHeaders) => {
  const res = await fetch(`${BASE}/${id}/paid`, {
    method: 'PATCH',
    headers: { ...authHeaders, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount_paid: amountPaid,
      discount_amount: discountAmount,
    }),
  });
  return parseApiResponse(res);
};
